type ServerLogTask = () => void | Promise<void>;

/**
 * Extend serverless handler lifetime so fire-and-forget log intake can finish.
 * Uses Next.js `after()` when running in a Next server context; otherwise runs
 * the task without blocking the caller.
 */
async function scheduleServerLogSubmission(task: ServerLogTask): Promise<void> {
  const isServerRuntime = ["edge", "nodejs"].includes(
    process.env.NEXT_RUNTIME ?? "",
  );

  if (isServerRuntime) {
    try {
      const { after } = await import("next/server");
      after(() => Promise.resolve(task()));
      return;
    } catch {
      // next/server is unavailable outside Next apps.
    }
  }

  void Promise.resolve(task());
}

export { scheduleServerLogSubmission };
